import { CSSProperties, ReactNode } from "react";
import { FormInstance } from "antd/lib/form";
import { IObject, IResponse } from "../constants/interface";
import { modeType, SelectValue, SelectOption, FieldNamesType } from "../SuperSelect/interface";
import { columnsProps, IGroupField } from "../SuperTable/interface";
import { SuperFormItemProps } from "../SuperForm/interface";
import { RouteLinkProps } from "../RouteLink/interface";

export interface SuperSelectTableProps extends MoreModalBaseProps {
  /** 样式 */
  style?: CSSProperties,
  /** 类名 */
  className?: string;
  /** 值 */
  value?: SelectValue;
  /** value对应得字段 */
  valueKey?: string;
  /** label对应字段 */
  labelKey?: string;
  /** subLabel对应字段 */
  subLabelKey?: string;
  /** 子节点对应字段 */
  childrenKey?: string;
  /** 子节点label对应字段 */
  childrenLabelKey?: string;
  /** 子节点value对应字段 */
  childrenValueKey?: string;
  /** 子节点subLabel对应字段 */
  childrenSubLabelKey?: string;
  /** 自定义节点 label、subLabel、value 的字段 */
  fieldNames?: FieldNamesType;
  /** 是否禁用 */
  disabled?: boolean;
  /** 搜索过滤key 默认等于labelKey */
  searchKey?: string;
  /** 是否为本地搜索 */
  isLocalSearch?: boolean;
  /** 搜索框提示 */
  searchPlaceholder?: string;
  /** 下拉选项的值对应data的那个字段 */
  dataKey?: string | false;
  /** 下拉列表标识 用于缓存 可能造成数据更新不及时 */
  selectTableKey?: string;
  /** 选项是否可以进行搜索 */
  showSearch?: boolean;
  /** 是否为表格类型接口 */
  isTableList?: boolean;
  /** 选择框默认文字 */
  placeholder?: string;
  /** 是否显示更多按钮 */
  showMore?: boolean;
  /** 更多按钮文字 */
  moreText?: ReactNode;
  /** 支持清除 */
  allowClear?: boolean;
  /** 初始默认下拉选项 */
  initOptions?: any[];
  /** 初始化时加载远程数据 */
  initialLoading?: boolean;
  /** 默认选中第一条 */
  defaultSelectedFirstItem?: boolean;
  /** 下拉菜单和选择器同宽。默认将设置 min-width，当值小于选择框宽度时会被忽略 */
  dropdownMatchSelectWidth?: number;
  /** 禁用时超出字符串是否省略 */
  isDisabledEllipsis?: boolean;
  /** 禁用时是否显示虚线的下边框 */
  disabledBorderDashed?: boolean;
  /** 禁用是显示内容 */
  disabledRender?: ReactNode | ((data?: any) => ReactNode);
  /** 是否每次点开下拉框都重新获取数据 */
  isOpenUpdate?: boolean;
  /** 禁用时是否可以复制 */
  copy?: boolean;
  /** 禁用文字链接配置 */
  routeLinkProps?: RouteLinkProps;
  /** 自定义选中标签显示 */
  onRenderLabel?: (record: any) => void;
  /** 过滤接口返回数据 */
  filterData?: (data: any[]) => any[];
  /** 自定义Option选项 */
  renderOption?: (record: any) => ReactNode;
  /** 失去焦点时回调 */
  onBlur?: () => void;
  /** 获得焦点时回调 */
  onFocus?: () => void;
  /** 数据获取成功回调 */
  onSuccess?: (data: any[]) => void;
  /** 选项发生改变是回调 */
  onChange?: (value?: SelectValue, item?: SelectOption | SelectOption[], form?: FormInstance, index?: number, record?: any) => void;
};

export interface MoreModalBaseProps {
  /** 接口API */
  fetchApi: (params: any) => Promise<IResponse>;
  /** 列配置 */
  columns?: columnsProps[]; // 列配置
  /** 额外参数 */
  otherParams?: IObject;
  /** 模式 */
  mode?: modeType;
  /** 列表搜索配置 */
  formItems?: SuperFormItemProps[];
  /** 表格头部是否显示已选数据的tab */
  moreTableShowTab?: boolean;
  /** 下拉匹配字段名称 */
  associateSelectNames?: string[] | string;
  /** 组合字段集合 */
  groupFields?: IGroupField[];
  /** 更多弹窗宽度 */
  moreModalSize?: ModalTableType | number;
  /** 菜单渲染父节点。默认渲染到 body 上 */
  getPopupContainer?: () => HTMLElement | HTMLElement;
  /** 获取数据之前回调 */
  beforeFetch?: (params: any, record?: any, index?: number) => any;
};

export enum MORE_MODAL_SIZE_ENUM {
  small = 600,
  middle = 850,
  large = 1100,
}
export type ModalTableType = 'middle' | 'large' | 'small';
